// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fDjx","productName":"Table_productName__2m1N1"};